import { get } from 'lodash';
import { playlistServices } from '../services';

export const fetchAllPlaylist = async (payload) => {
  try {
    const res = await playlistServices.fetchAllPlaylist(payload);
    console.log('res', res);
    return get(res, 'data.data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const createPlaylist = async (payload) => {
  try {
    const res = await playlistServices.createPlaylist(payload);
    return get(res, 'data.data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const deletePlaylist = async (id) => {
  try {
    const res = await playlistServices.deletePlaylist(id);
    return get(res, 'data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const fetchPlaylistById = async (id) => {
  try {
    const res = await playlistServices.fetchPlaylistById(id);
    return get(res, 'data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const uploadPlaylistImage = async (id, file) => {
  try {
    // Step 1: Get Signed URL
    const signedUrlRes = await playlistServices.getPlaylistImageUploadUrl(id, {
      filename: file.name,
      mimetype: file.type,
    });

    const signedUrlData = get(signedUrlRes, 'data.data');
    if (!signedUrlData) return [];

    const { signed_url, key } = signedUrlData;

    // Step 2: Upload to R2
    const uploadRes = await fetch(signed_url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    if (!uploadRes.ok) return [];

    // Step 3: Save Record
    const res = await playlistServices.uploadPlaylistImage(id, {
      image_key: key,
    });
    return get(res, 'data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const updatePlaylist = async (id, payload) => {
  try {
    const res = await playlistServices.updatePlaylist(id, payload);

    return get(res, 'data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const copyPlaylist = async (id, payload) => {
  try {
    const res = await playlistServices.copyPlaylist(id, payload);
    return get(res, 'data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};
